import { gql } from '@apollo/client';

const UPDATE_SELECTED_REWARDS = gql`
  mutation selectStudentReward($data: SelectStudentRewardInput!) {
    selectStudentReward(data: $data) {
      studentRewards {
        reward {
          id
          asset {
            id
            src
            description
          }
        }
        id
        studentId
        characterId
        selected
      }
    }
  }
`;

export default UPDATE_SELECTED_REWARDS;
